<div class="global-modal" [class.global-modal--left]="config.align === 'left'">
  <div class="global-modal-header">
    <h4 class="global-modal-title" id="global-modal-title">
      <i *ngIf="config.icon" class="{{ config.icon }} {{ config.iconClass }} me-2"></i>
      {{ config.title }}
    </h4>
    <p *ngIf="config.subtitle" class="global-modal-subtitle mb-0">
      {{ config.subtitle }}
    </p>
    <button type="button" class="global-modal-close" aria-label="Close" aria-describedby="global-modal-title" [disabled]="loading" (click)="cancel()">
      <i class="bi bi-x-lg" aria-hidden="true"></i>
    </button>
  </div>

  <div class="global-modal-body">
    <ng-content></ng-content>

    <p *ngIf="config.message" class="global-modal-message mb-0">
      {{ config.message }}
    </p>
    <ul *ngIf="config.points?.length" class="global-modal-points">
      <li *ngFor="let point of config.points">{{ point }}</li>
    </ul>
    <p *ngIf="config.subMessage" class="global-modal-submessage text-danger mt-2 mb-0">
      {{ config.subMessage }}
    </p>

    <div *ngIf="config.highlightItems?.length" class="global-modal-highlight mt-3">
      <span *ngIf="config.highlightLabel" class="global-modal-highlight-label">
        {{ config.highlightLabel }}
      </span>
      <div class="global-modal-highlight-items">
        <span *ngFor="let item of config.highlightItems" class="global-modal-chip">
          {{ item }}
        </span>
      </div>
    </div>
  </div>

  <div class="global-modal-footer">
    <button *ngIf="!config.hideCancel" type="button" class="btn {{ cancelBtnClass }}" [disabled]="loading" (click)="cancel()">
      {{ cancelText }}
    </button>
    <button type="button" class="btn {{ confirmBtnClass }}" [disabled]="loading || config.confirmDisabled" (click)="confirm()">
      <span *ngIf="loading" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
      {{ confirmText }}
    </button>
  </div>
</div>
